import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Box,
  DialogContentText,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import styles from './ModalConcluido.style';

const useStyles = makeStyles(styles);

function ModalConcluido({ push, show }) {
  const classes = useStyles();

  return (
    <>
      <Dialog open={show} classes={{ paper: classes.paper }}>
        <DialogTitle classes={{ root: classes.root }}>
          <Typography>Pré-cadastro realizado!</Typography>
        </DialogTitle>
        <DialogContent classes={{ root: classes.content }}>
          <Box display="flex" flexDirection="column" justifyContent="space-between" mb={1}>
            <DialogContentText variant="body2">
              O usuário receberá um e-mail para aprovação e finalização do cadastro via plataforma.
            </DialogContentText>
          </Box>
          <DialogActions className={classes.boxButtons}>
            <Button
              onClick={() => push('/base-usuarios/pre-cadastro')}
              color="primary"
              className={classes.buttonStyleWithContainer}
            >
              Entendi
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
}

ModalConcluido.propTypes = {
  show: PropTypes.bool.isRequired,
  push: PropTypes.func.isRequired,
};

export default ModalConcluido;
